<button type="button" class="btn btn-{{ buttonClass }}" [disabled]="showSpinner || disabled" (click)="submit()">
  @if (showSpinner) {
  <img class="spin-img" src="assets/images/svg/Spinner-s.svg" alt="" />
  }
  {{ label }}
</button>
